export default () => ({
  loading: false,
  currentAgenda: {},
  currentProfessional: {},
  date: null,
  currentSchedule: {},
  showModal: false,
  agenda_id: null,
  agenda: {
    address: {},
    schedules: [],
    schedules_integration_offline: []
  },
  dates: [],
  showModalCancel: false,
  hideShowModalCancel: false,
  showModalDelayed: false,
  showModalConfirmed: false,
  showModalAbsent: false,
  showModalInAttendance: false,
  showModalPresent: false,
  showModalFromDelayedRollback: false,
  showModalRollback: false,
  showModalTransfer: false,
  showModalReverser: false,
  showModalReserved: false,
  showModalAvailable: false
})



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/company/gadget/components/schedulings/resources/data.js